import { Box } from 'braid-design-system';

import * as styles from './MediaContainer.css';

export type ImageRatio = '1x1' | '3x2' | '4x3' | '16x9';

export interface Props {
  src: string;
  altText?: string;
  ratio: ImageRatio;
}

const ImageContainer = ({ src, altText = '', ratio }: Props) => (
  <Box
    position="relative"
    overflow="hidden"
    className={styles.mediaRatio[ratio]}
  >
    <img src={src} alt={altText} className={styles.item} />
  </Box>
);

export default ImageContainer;
